import { render } from "./BaseInputNumber.vue?vue&type=template&id=032723ca"
import script from "./BaseInputNumber.vue?vue&type=script&lang=js"
export * from "./BaseInputNumber.vue?vue&type=script&lang=js"

import "./BaseInputNumber.vue?vue&type=style&index=0&id=032723ca&lang=scss"
script.render = render

export default script